import React from "react";
import * as Icons from "lucide-react";
import { SERVICES, buildWaLink, serviceMessage, trackWhatsApp } from "@/lib/services";
import { useI18n } from "@/lib/i18n";

const DEFAULT_ICON = Icons.Stethoscope;

export default function AllServicesGrid() {
  const { t } = useI18n();
  return (
    <section data-testid="services-section" id="services" className="py-16 md:py-24 bg-soft-blue">
      <div className="container-x">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-2xl">
            <h2 className="text-[32px] md:text-[44px] font-extrabold text-navy">{t("services.h2")}</h2>
            <p className="mt-3 text-ink/85">{t("services.sub")}</p>
          </div>
          <a href="https://wa.me/917483985244" target="_blank" rel="noopener noreferrer" className="btn-wa text-[14.5px]">
            Open WhatsApp
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s) => {
            const Icon = Icons[s.icon] || DEFAULT_ICON;
            const WhatsAppIcon = Icons.MessageCircle;
            return (
              <a
                key={s.slug}
                data-testid={`service-tile-${s.slug}`}
                href={buildWaLink(serviceMessage(s.name))}
                target="_blank" rel="noopener noreferrer"
                onClick={() => trackWhatsApp(s.name)}
                aria-label={`Chat on WhatsApp about ${s.name}`}
                className="group block bg-white rounded-2xl border border-navy/10 p-6 hover-care"
                style={{ minHeight: 160 }}
              >
                <div className="flex items-start justify-between">
                  <span className="icon-tile"><Icon className="w-6 h-6" /></span>
                </div>
                <h3 className="mt-5 text-[18px] md:text-[19px] font-bold text-navy leading-snug">{s.name}</h3>
                <p className="mt-1.5 text-[14.5px] text-ink/75">{s.desc}</p>

                <div className="mt-5 inline-flex items-center gap-1.5 text-[13.5px] font-bold text-[#1EB757] md:opacity-0 md:group-hover:opacity-100 transition-opacity">
                  <WhatsAppIcon className="w-4 h-4" style={{ color: "#25D366" }} />
                  Chat on WhatsApp →
                </div>
              </a>
            );
          })}
        </div>

        <p className="mt-8 text-[13px] text-ink/65 text-center">
          IV injections &amp; clinical procedures are performed only as per doctor's advice or valid prescription.
        </p>
      </div>
    </section>
  );
}
